import { createContext, useContext, useRef, useCallback } from 'react';
import type { ReactNode } from 'react';

interface VapiContextValue {
  triggerCall: () => void;
  registerTrigger: (fn: () => void) => void;
}

const VapiContext = createContext<VapiContextValue>({
  triggerCall: () => {},
  registerTrigger: () => {},
});

export function VapiProvider({ children }: { children: ReactNode }) {
  const triggerRef = useRef<(() => void) | null>(null);

  const registerTrigger = useCallback((fn: () => void) => {
    triggerRef.current = fn;
  }, []);

  const triggerCall = useCallback(() => {
    triggerRef.current?.();
  }, []);

  return (
    <VapiContext.Provider value={{ triggerCall, registerTrigger }}>
      {children}
    </VapiContext.Provider>
  );
}

export const useVapi = () => useContext(VapiContext);
